module.exports = __webpack_public_path__ + "static/media/21510_warmwind_logo-removebg-preview.be5e5163.png";